import {Box} from '@mui/material';
import {formatDecimal} from './ingredientAmount';

interface Props {
    quantity: number;
    unit?: string;
}

export const AmountValue = ({quantity, unit}: Props) => (
    <Box
        component="span"
        sx={{
            display: 'inline-grid',
            gridTemplateColumns: '8ch 4ch',
            columnGap: 0.75,
            textAlign: 'left',
            whiteSpace: 'nowrap',
        }}
    >
        <Box component="span">{formatDecimal(quantity)}</Box>
        <Box component="span">{unit}</Box>
    </Box>
);
